import React from 'react';
import { Select } from 'antd';
import { SelectedTag } from './SelectedTag';
import { OptionItem } from './OptionItem';
import type { BaseOptionType, CustomMultiselectProps } from './types';
import { DropdownWrapper } from './styles';

interface MultiSelectInputProps<T extends BaseOptionType = BaseOptionType> extends CustomMultiselectProps<T> {
	isOpen: boolean;
	onDropdownVisibleChange: (open: boolean) => void;
}

export function MultiSelectInput<T extends BaseOptionType = BaseOptionType>({
	options = [],
	value = [],
	placeholder,
	onChange,
	isOpen,
	onDropdownVisibleChange,
	...rest
}: MultiSelectInputProps<T>): JSX.Element {
	return (
		<Select
			mode="multiple"
			allowClear={rest.allowClear}
			placeholder={placeholder}
			value={value}
			onChange={(vals, opts) => {
				const selectedOptions = Array.isArray(opts) ? opts : [opts];
				onChange(vals as string[], selectedOptions as T[]);
			}}
			open={isOpen}
			onDropdownVisibleChange={onDropdownVisibleChange}
			tagRender={(props) => <SelectedTag {...props} />}
			suffixIcon={null}
			popupClassName="multi-select-dropdown"
			optionLabelProp="label"
			style={{ width: '100%', ...rest.style }}
			dropdownStyle={rest.dropdownStyle}
			dropdownClassName={rest.dropdownClassName}
			disabled={rest.disabled}
			showSearch={rest.showSearch}
			maxTagCount={rest.maxTagCount}
			maxTagTextLength={rest.maxTagTextLength}
			onSearch={rest.onSearch}
			onClear={rest.onClear}
			filterOption={rest.filterOption}
			dropdownRender={(menu) => <DropdownWrapper>{menu}</DropdownWrapper>}
		>
			{options.map((opt) => (
				<Select.Option key={opt.value} value={opt.value} label={opt.label}>
					<OptionItem option={opt} checked={value.includes(opt.value)} />
				</Select.Option>
			))}
		</Select>
	);
}
